var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    ref: "stickyHeader",
    staticClass: "sticky-title-row",
    class: {
      'is-scrolled': _vm.isScrolled
    }
  }, [_vm.breadcrumbItems.length ? _c('v-breadcrumbs', {
    staticClass: "pa-0 pt-8",
    attrs: {
      "large": "",
      "items": [{
        text: 'Főoldal',
        to: {
          name: 'Home'
        }
      }].concat(_vm.breadcrumbItems),
      "divider": "/"
    }
  }) : _vm._e(), _c('div', {
    staticClass: "py-4 d-flex align-center flex-wrap"
  }, [_c('div', {
    staticClass: "py-1"
  }, [_c('h2', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.title))]), _vm.subtitle ? _c('div', [_vm._v(_vm._s(_vm.subtitle))]) : _vm._e()]), _c('v-spacer'), _c('div', {
    staticClass: "d-flex justify-end align-center flex-grow-1 flex-wrap py-1"
  }, [_vm._t("buttons")], 2)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }